"use client";
import S3Image from "@/components/S3Image";
import { useSite } from "@/lib/hooks/site";
import localImageLoader from "@/lib/local-image-loader";
import SmileWomanDesktop from "../../../../../public/SmileWomanDesktop.webp";
import { useTranslation } from "@/hooks/translationContext";
import { useCallback } from "react";

export default function BulkOfferDesktopImage() {
  const site = useSite();
  const { t } = useTranslation();

  const getQuoteImage = useCallback(() => {
    const calltoaction = site?.setting?.design?.calltoaction;
    if (calltoaction?.["general-quote"]) {
      return `site/${site.id}/assets/${calltoaction["general-quote"]}`;
    }
  }, []);

  return (
    <S3Image
      sizes="140px"
      loading="lazy"
      loader={!getQuoteImage() ? localImageLoader : undefined}
      src={getQuoteImage() || SmileWomanDesktop}
      alt={`${t("venue-offer-image-alt")} ~ ${site.descriptions[0]?.title}`}
      title={`${t("venue-offer-image-alt")} ~ ${site.descriptions[0]?.title}`}
      width={140}
      height={140}
      className="w-[140px] ml-2 absolute"
      style={{
        maxWidth: "100%",
      }}
    />
  );
}
